import React, { useState, useEffect } from "react";
import { StyleSheet, css } from 'aphrodite';


import image5 from "../../assets/LabImage5.png";
import image6 from "../../assets/new1.jpg";
import image7 from "../../assets/new2.jpg";
import { Flex, Image } from "@chakra-ui/react";

import { useSelector } from "react-redux";

import image13 from "../../assets/sld 6.png";
import image10 from "../../assets/sld 3.png";
import image11 from "../../assets/sld 4.png";



const images = [image5, image13, image6, image7, image11, image10,  /* Add more imported images here */];


function Carousel2() {
  const [currentImage, setCurrentImage] = useState(images.length - 1);;
  const [transitioning, setTransitioning] = useState(false);

  const isMobile = useSelector(state => state.windowSize.isMobile);
  const dynamicHeight = isMobile ? "30vh" : "70vh";

  const nextSlide = () => {
    if (!transitioning) {
      setTransitioning(true);
      setTimeout(() => {
        setCurrentImage((prevImage) =>
          prevImage === images.length - 1 ? 0 : prevImage + 1
        );
        setTransitioning(false);
      }, 500); // Adjust the transition duration (in milliseconds)
    }
  };

  

  useEffect(() => {
    const interval = setInterval(nextSlide, 2000); // Change image every 2 seconds
    return () => clearInterval(interval); // Cleanup on unmount
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex className={css(styles.carousal)} height={dynamicHeight} >
        <Flex className={css(styles.slideContainer)}>
        {images.map((_, index) => (
            <Flex
                key={index}
                className={css(styles.slide, currentImage === index && styles.currentSlide, transitioning && styles.slideTransition)}
                onClick={() => setCurrentImage(index)}
            >
                <Image
                src={images[currentImage]}
                alt={`Slide ${currentImage + 1}`}
                style={{
                    justifyContent: 'center',
                    objectFit: 'contain',
                    width: '75%',
                    height: '50%'
                }}
                />
            </Flex>
            ))}
      </Flex>
    </Flex>
  );
}


const styles = StyleSheet.create({
  
    carousal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100vw',
        overflow: 'hidden',
        position: 'relative',
        marginTop: 0
    },
    slideContainer: {
        display: "flex",
        transition: "transform 0.8s ease", // CSS transition for sliding effect
        minWidth: '100vw',
      },
      slide: {
        flex: "0 0 100%",
        alignContent: 'center',
        justifyContent: 'center',
        height: '100%'
    },
    imageStyle: {
        alignContent: 'center',
    },
    currentSlide: {
        transform: "translateX(0%)", // Start from the right-most image
      },
      slideTransition: {
        transform: "translateX(-100%)", // Slide transition effect
      },
})

export default Carousel2;
